import React from "react";
import { useSearchParams } from "react-router-dom";
import { MuiTab } from "@ace/ace-ui-web";
import { Typography, Container, Stack, Box } from '@mui/material';
import KPIReportPage from "../kpi-report";
import GigReportPage from "../gig-report";
import CalendarReportView from "../calendar-view-report/CalendarReportView";
import TableReportView from "../table-view-report/TableReportView";
import DashboardReportView from "../dashboard-report/DashboardReportView";

const TAB_KEYS = ['dashboard', 'calendar', 'table', 'kpi', 'gig'] as const;
type TabKey = typeof TAB_KEYS[number];

const ReportsPage: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = (searchParams.get('tab') as TabKey) ?? null;
    const initialIndex = tabParam && TAB_KEYS.includes(tabParam) ? TAB_KEYS.indexOf(tabParam) : 0;

    const handleTabChange = (index: number) => {
        const next = new URLSearchParams(searchParams);
        next.set('tab', TAB_KEYS[index]);
        // Clear deep-link params when the user manually switches tabs.
        next.delete('requestId');
        next.delete('seqId');
        setSearchParams(next, { replace: true });
    };

    return (
        <Container
            maxWidth={false}
            sx={{
                py: { xs: 2.5, md: 3, lg: 3.5, xl: 4 },
                px: { xs: 1, sm: 2, md: 3.5, lg: 4, xl: 5 }
            }}
        >
            <Stack spacing={2.5}>
                <Stack spacing={0.5}>
                    <Typography variant="h3" component="h1" className="page-title">
                        Reports Dashboard
                    </Typography>
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <MuiTab
                        fontSize="default"
                        fontWeight="default"
                        value={initialIndex}
                        onChange={handleTabChange}
                        tabs={[
                            {
                                label: 'Dashboard',
                                content: <DashboardReportView />
                            },
                            {
                                label: 'Calendar Overview',
                                content: <CalendarReportView />
                            },
                            {
                                label: 'Table Summary',
                                content: <TableReportView />
                            },
                            {
                                label: 'KPI Report',
                                content: <KPIReportPage />
                            },
                            {
                                label: 'GIG Report',
                                content: <GigReportPage />
                            },
                        ]}
                        variant="button"
                    />
                </Box>
            </Stack>
        </Container>
    );
};

export default ReportsPage;